<template>
    <div class="Lupakatalaluan">
        <v-snackbar
        :timeout="snackbar.timeout"
        :color="snackbar.color"
        v-model="snackbar.show"
        >
        {{ snackbar.message }}
        </v-snackbar>
        <!-- <v-content> -->
            <v-form ref="formresetkalalaluan">
            <v-card width="500" class="mx-auto mt-9">
                <v-card-title>{{$t('lupakatalaluan')}}</v-card-title>
                
                <v-card-text>
                    <v-text-field 
                    outlined dense
                    v-bind:label="$t('emel')"
                    prepend-icon="mdi-email"
                    v-model="lupakatalaluanemel"
                    :rules="[required('emel'), rules.email]"
                    />
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                        <v-btn rounded color="success" @click="resetkatalaluan">{{$t('hantar')}}</v-btn> 
                        <v-btn rounded color="light-blue darken-2  white--text" @click="kembali">{{$t('kembali')}}</v-btn> 
                </v-card-actions>
            </v-card>
            </v-form>
        <!-- </v-content> -->
    </div>
</template>
<script>
import axios from 'axios'
import i18n from '@/i18n'
export default {
    name: 'Lupakatalaluan',
    data: () => ({
        snackbar: "",
        lupakatalaluanemel: '',
        passReset:'',
        required(text){
            return (v) => 
                (v && v.length > 0) || `${i18n.t(text)} ${i18n.t('adalahdiperlukan')}`
        },
        rules: {
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || `${i18n.t('emeltidaklengkap')}`;
          }
        }
    }),
     methods:{
         kembali(){
            this.$router.push(`/${i18n.locale}/`).catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                    throw err;
                }
            });
        },
         async resetkatalaluan(){
            if(this.$refs.formresetkalalaluan.validate()){
                await axios.post(`${process.env.VUE_APP_API_URL}/penggunasistem/tetapkansemulakatalaluan`, {
                    lupakatalaluanemel: this.lupakatalaluanemel,
                })
                .then(response =>{
                    var pss = response.data.pswrd;
                    if(!response.data.status){
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: `${i18n.t('emelxwujud')}`,
                            timeout: 2000
                        })
                    } else {
                        alert(`Katalaluan di hantar ke ${this.lupakatalaluanemel} password : `+pss)
                        // this.snackbar = {
                        //     message: i18n.t("katalaluantelahdihantar"),
                        //     timeout: 2000,
                        //     color: "success",
                        //     show: true,
                        // };
                            this.$router.push(`/${i18n.locale}/`).catch(err => {
                            if (err.name !== 'NavigationDuplicated') {
                                throw err;
                            }
                        });
                    }
                    
                    
                    console.log(response.data.status)
                })
                .catch(error => {
                    console.log(error)
                    alert(error)
                })
            }
         }
     },
    setup() {
        
    },
}
</script>